import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { FileUpload } from "../FileUpload";
import { Section, Field, fileSrc } from "./builderUi";

const TILES = ["bg-cobalt text-sand", "bg-tangerine text-ink", "bg-grass text-sand", "bg-blossom text-ink", "bg-ink text-sand"];
const tileFor = (name = "") => {
  let h = 0;
  for (let i = 0; i < name.length; i += 1) h = ((h << 5) - h + name.charCodeAt(i)) | 0;
  return TILES[Math.abs(h) % TILES.length];
};

const NameTile = ({ name }) => {
  const first = (name || "").trim().split(/\s+/)[0] || "You";
  return (
    <div className={`flex h-full w-full flex-col items-center justify-center ${tileFor(first)}`} data-testid="builder-avatar-fallback">
      <span className="font-serif text-3xl italic leading-none">{first.charAt(0).toUpperCase()}</span>
      <span className="mt-1 max-w-[88%] truncate text-[13px] font-semibold uppercase tracking-[0.16em] opacity-80">{first}</span>
    </div>
  );
};

/**
 * Profile photo is optional: without one, donors see the palette tile with the
 * student's first name (the same fallback the public page uses).
 */
export const ProfileBioSection = ({ form, set, campaignId, coverFileId, onCoverChange }) => {
  const coverRecord = coverFileId
    ? { id: coverFileId, url: `/api/files/${coverFileId}?auth=${localStorage.getItem("mra_jwt") || ""}`, original_filename: "Profile photo", content_type: "image" }
    : null;
  return (
    <Section accent="bg-blossom" title="Profile photo & bio" subtitle="A photo is optional. Without one, donors see your name on a color tile — many students prefer it." testid="builder-profile">
      <div className="flex flex-col gap-7 sm:flex-row">
        <div className="flex shrink-0 flex-col items-center gap-3">
          <div className="h-28 w-28 overflow-hidden rounded-full border border-border" data-testid="builder-avatar">
            {coverFileId ? (
              <img src={fileSrc(coverFileId)} alt="" className="h-full w-full object-cover" />
            ) : (
              <NameTile name={form.full_name} />
            )}
          </div>
          <span className="text-[13px] font-semibold uppercase tracking-[0.18em] text-olive">How donors see you</span>
        </div>
        <div className="flex-1 space-y-5">
          <FileUpload
            purpose="campaign_cover"
            label="Profile photo (optional)"
            hint="JPG, PNG or WebP up to 8 MB. Make sure your face is in it."
            testid="builder-upload-cover"
            campaignId={campaignId}
            value={coverRecord}
            onChange={onCoverChange}
          />
          <Field label="Headline" optional>
            <Input data-testid="builder-headline" value={form.headline} onChange={set("headline")} placeholder="Aspiring software engineer & community volunteer" maxLength={140} />
          </Field>
          <Field label="Biography" counter={`${form.bio.length}/500`}>
            <Textarea data-testid="builder-bio" maxLength={500} rows={4} value={form.bio} onChange={set("bio")} placeholder="Tell donors who you are — where you're from, what you're studying, what you care about." />
          </Field>
        </div>
      </div>
    </Section>
  );
};
